import React, { useState, useMemo } from "react";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { setAlert } from "actions/alert";
import {
  resetPassword,
  setPasswordError,
  getResetTokenStatus,
  tokenInvalid,
  loginRedirect,
} from "actions/auth";
import Errors from "views/Notifications/Errors";
import Alert from "views/Notifications/Alert";
import Spinner from "views/Spinner";

import PropTypes from "prop-types";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  Input,
  InputGroup,
  InputGroupText,
  Row,
  CardText,
} from "reactstrap";

const ResetPassword = ({
  setAlert,
  setPasswordError,
  resetPassword,
  getResetTokenStatus,
  tokenInvalid,
  history,
  errorList,
  match,
  loading,
  loginRedirect,
}) => {
  const [formData, setFormData] = useState({
    password: "",
    confirm_password: "",
  });
  const [successful, setSuccessful] = useState(false);

  useMemo(() => {
    getResetTokenStatus(match.params.token).then((data) => {
      !data && tokenInvalid(history);
    });
  }, [getResetTokenStatus, match.params.token, history, tokenInvalid]);

  const { password, confirm_password } = formData;

  const onChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm_password) {
      setPasswordError("Passwords do not match", "confirm_password");
      setAlert(
        "Errors! Please correct the following errors and submit again.",
        "danger"
      );
    } else {
      resetPassword(password, match.params.token).then((res) => {
        if (res && res.status === true) {
          setSuccessful(true);
        }
      });
    }
  };

  const [hidden, setHidden] = useState(true);
  const [icon, setIcon] = useState("icon-eye");
  const onClickPasswordIcon = (e) => {
    setHidden(!hidden);
    setIcon(icon === "icon-eye" ? "icon-lock-open" : "icon-eye");
  };

  return (
    <div className="app flex-row align-items-center">
      <Container>
        <Row className="justify-content-center">
          <Col md="9" lg="7" xl="6">
            <Card className="mx-4">
              <CardBody className="p-4">
                {successful ? (
                  <CardText>
                    <span>
                      Password has been reset successfully. Click here to{" "}
                    </span>
                    <Link to="/login" title="login">
                      Login
                    </Link>
                  </CardText>
                ) : (
                  <Form onSubmit={(e) => onSubmit(e)}>
                    <h1>Reset Password</h1>
                    <Alert />
                    <InputGroup className="mb-3">
                      <InputGroupText>
                        <i className="icon-lock"></i>
                      </InputGroupText>
                      <Input
                        type={hidden ? "password" : "text"}
                        placeholder="Password"
                        autoComplete="password"
                        name="password"
                        minLength="8"
                        value={password}
                        onChange={(e) => onChange(e)}
                        invalid={errorList.password ? true : false}
                      />
                      <InputGroupText
                        onClick={(e) => onClickPasswordIcon(e)}
                        title="Click to show/hide password"
                      >
                        <i className={icon}></i>
                      </InputGroupText>
                      <Errors current_key="password" key="password" />
                    </InputGroup>
                    <InputGroup className="mb-4">
                      <InputGroupText>
                        <i className="icon-lock"></i>
                      </InputGroupText>
                      <Input
                        type="password"
                        placeholder="Confirm password"
                        autoComplete="confirm_password"
                        name="confirm_password"
                        minLength="8"
                        value={confirm_password}
                        onChange={(e) => onChange(e)}
                        invalid={errorList.confirm_password ? true : false}
                      />
                      <Errors
                        current_key="confirm_password"
                        key="confirm_password"
                      />
                    </InputGroup>
                    <Row>
                      {loading ? (
                        <Spinner />
                      ) : (
                        <>
                          <Col xs="6">
                            <Button color="primary" className="px-6">
                              Reset Password
                            </Button>
                          </Col>
                          <Col xs="6" className="text-right">
                            <Button
                              color="link"
                              className="px-0"
                              onClick={(e) => loginRedirect(history)}
                            >
                              Have an account? Login
                            </Button>
                          </Col>
                        </>
                      )}
                    </Row>
                  </Form>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

ResetPassword.propTypes = {
  setAlert: PropTypes.func.isRequired,
  setPasswordError: PropTypes.func.isRequired,
  resetPassword: PropTypes.func.isRequired,
  getResetTokenStatus: PropTypes.func.isRequired,
  tokenInvalid: PropTypes.func.isRequired,
  loginRedirect: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool,
  errorList: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
  errorList: state.errors,
  loading: state.auth.loadingPasswordReset,
});

export default connect(mapStateToProps, {
  setAlert,
  setPasswordError,
  resetPassword,
  getResetTokenStatus,
  tokenInvalid,
  loginRedirect,
})(withRouter(ResetPassword));
